export const environmentProtheus = {
    production: false,
    url: '/api/com/v1',
    urlFrame: '/api/framework/v1'
  };
  